import { Injectable, inject } from "@angular/core";
import { RealTimeDataStore } from "@app/services/store/real-time-data-store";
import { WebStompEntitySubscriber } from "@app/services/webstomp/web-stomp-entity-subscriber.service";
import { WebhookStaging } from "@app/models/rest/webhook-staging";
import { WebhookStagingRestService } from "@app/services/hal/webhook-staging-rest.service";
import { HateoasResourceService } from "@lagoshny/ngx-hateoas-client";

@Injectable({ providedIn: "root" })
export class WebhookStagingStore extends RealTimeDataStore<WebhookStaging> {
  constructor() {
    const webhookStagingRestService = inject(WebhookStagingRestService);
    const webStompSubscriber = inject(WebStompEntitySubscriber);
    const hateoasResourceService = inject(HateoasResourceService);

    super(
      webhookStagingRestService,
      webStompSubscriber,
      hateoasResourceService
    );
    super.subscribeToMessaging("WebhookStaging");
  }
}
